import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { User } from '../models/user.model';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(
    public router: Router,
    private auth: AuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user: User = this.auth.currentUserValue;
    if (!!user) {
      if (route.data['roles'] && route.data['roles'].indexOf(user.role) === -1) {
        if (this.auth.currentUserValue.role === 'doco' && state.url.includes('submit-photo')) {
          this.router.navigate(['/doco'])
        } else {
          this.router.navigate([environment.homeUrl]);
        }

        return false;
      }
      return true;
    }
    this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

}
